@use '~/theme/theme' as *;
@use '~/theme/typography';

.check {
  color: color(green-800);
}

.cross {
  color: color(lobster-800);
}

.tooltipIcon {
  appearance: none;
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  cursor: pointer;

  &:hover,
  &[data-focus-visible] {
    outline: 2px solid color(violet-600);
    outline-offset: 2px;
    border-radius: 2px;
  }
}

.tooltip {
  background: white;
  min-width: 450px;

  table {
    border-spacing: 0;
  }

  th,
  td {
    border: none;
    padding: spacing(1);

    @include typography.tabular-nums;
    @include typography.caption;
    @include typography.medium;

    text-align: right;
  }

  td:first-of-type {
    padding: spacing(1) spacing(2);
    text-align: left;
  }

  th {
    background-color: color(grey-100);
    color: color(grey-700);
  }

  .balancedIndicator {
    width: 100%;
  }
}
